import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import NavTabs from "../../components/NavTabs";
import Sidebar from "../../components/SideBar";
import List from "../../components/List";
import Label from "../../components/Label";
import Button from "../../components/Button";
import tableIcons from "../../config/tableIcons";
import Register from "./Register";

import { Dialog, DialogContent } from "@material-ui/core";

import Enroll from "../../services/enroll";

import { Line } from "./styles";
import { getImprimixApiToken } from "../../utils/TokenCache";

const Users = () => {
  const [open, setOpen] = useState(false);
  const history = useHistory();

  const columns = [
    { field: "id", title: "ID", type: "numeric" },
    { field: "name", title: "Nome" },
    { field: "email", title: "Email" },
    { field: "enable", title: "Status" },
    { field: "profiles.name", title: "Perfil" },
  ];

  const actions = [
    {
      icon: tableIcons.Delete,
      tooltip: "Deletar Usuário",
      onClick: (e, request) => {
        return Enroll.deleteUser(request.id)
          .then((resp) => {
            if (!!resp.response) {
              console.log(resp.response.data.error);
            } else {
              console.log(resp.status);
              window.location.reload();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    },
  ];

  const getRows = () => {
    return Enroll.getUsers()
      .then((resp) => {
        if (!!resp.data) return resp.data.data;
        return [];
      })
      .catch(function (error) {
        return [];
      });
  };

  const data = [
    {
      name: "Usuários",
      content: (
        <List columns={columns} rows={[]} getRows={getRows} actions={actions} />
      ),
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const page = (
    <>
      <Line>
        <Label
          className="first"
          size="min"
          color="dark"
          align="left"
          weight="500"
        >
          Usuários Cadastrados
        </Label>
        <div>
          <Button
            size="nano"
            color="dark"
            format="solid"
            width="100%"
            onClick={handleOpen}
          >
            Novo Usuário
          </Button>
        </div>
      </Line>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Register close={handleClose} />
        </DialogContent>
      </Dialog>
      <div style={{ maxWidth: "100%" }}>
        <NavTabs itens={data} />
      </div>
    </>
  );

  return <Sidebar current="Usuários" content={page} />;
};

export default Users;
